import { mediaLogos, mediaDecisions } from "@/content/site-content";
import { logoSize } from "@/lib/logo-size";

type Logo = { src: string; name: string };

const seen = new Set<string>();
const logos: Logo[] = [...mediaLogos, ...mediaDecisions].reduce<Logo[]>((acc, item) => {
  if (!item.src || seen.has(item.src)) return acc;
  seen.add(item.src);
  acc.push({ src: item.src, name: item.name });
  return acc;
}, []);

export function LogoMarquee({
  label = "Publikacje i wystąpienia w mediach",
  exclude = [],
}: {
  label?: string;
  exclude?: string[];
}) {
  const visibleLogos = logos.filter((logo) => !exclude.includes(logo.name));

  function VisibleRow({ ariaHidden }: { ariaHidden?: boolean }) {
    return (
      <ul
        className="marquee-track flex shrink-0 items-center gap-10 pr-10 sm:gap-14 sm:pr-14"
        aria-hidden={ariaHidden ? "true" : undefined}
      >
        {visibleLogos.map((logo) => (
          <li key={`${ariaHidden ? "b" : "a"}-${logo.src}`} className="shrink-0">
            <img
              src={logo.src}
              alt={ariaHidden ? "" : `Logo, ${logo.name}`}
              {...logoSize(logo.src)}
              loading="lazy"
              decoding="async"
              className="h-10 w-auto max-w-[8rem] object-contain opacity-60 grayscale transition duration-300 hover:opacity-100 hover:grayscale-0 sm:h-12 sm:max-w-[10rem]"
            />
          </li>
        ))}
      </ul>
    );
  }

  return (
    <div className="marquee" aria-label={label} role="group">
      <div className="marquee-inner flex w-max">
        <VisibleRow />
        <VisibleRow ariaHidden />
      </div>
    </div>
  );
}
